<template>
  <div class="hideTotal">
    <!-- 搜索 -->
    <table-search
      label-width="65px"
      @search="fetchList(1)"
      @reset="handleReset"
    >
      <template v-slot:basic>
        <!-- <el-form-item label="组织">
          <el-select
            v-model="query.marketId"
            placeholder="请选择组织"
          >
            <el-option
              v-for="(item, index) in $key.spotPurchaseSaleInquiry.organization"
              :key="index"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item> -->
        <el-form-item label="客户">
          <el-input
            v-model="query.userAccount"
            placeholder="请输入客户"
          />
        </el-form-item>
        <el-form-item label="客户号">
          <el-input
            v-model="query.tradeUserAccount"
            placeholder="请输入客户号"
          />
        </el-form-item>
        <el-form-item label="委托编号">
          <el-input
            v-model="query.entrustNo"
            placeholder="请输入委托编号"
          />
        </el-form-item>
        <el-form-item label="订变">
          <el-select
            v-model="query.entrustTs"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in $key.spotPurchaseSaleInquiry.entrustTs"
              :key="index"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="购销">
          <el-select
            v-model="query.entrustBs"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in $key.spotPurchaseSaleInquiry.entrustBs"
              :key="index"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="套利购销计划"
          class="arbitragePSPlane"
          label-width="95px"
        >
          <el-input
            v-model="query.goodsCode"
            style="width:45%;float:left"
            placeholder="近期购销计划代码"
          />
          <span style="position: absolute; left: 49%">&</span>
          <el-input
            v-model="query.goodsCodeOther"
            style="width:45%;float:right"
            placeholder="远期购销计划代码"
          />
        </el-form-item>
        <el-form-item
          label="委托日期"
          class="datePicker"
        >
          <el-date-picker
            v-model="query.date"
            is-range
            arrow-control
            type="daterange"
            range-separator="至"
            start-placeholder="起始日期"
            end-placeholder="截止日期"
            placeholder="选择时间范围"
          />
        </el-form-item>
      </template>
    </table-search>
    <!-- 导出 -->
    <inquery-result isTips @export="toDownload" />
    <!-- 表格 -->
    <el-table
      ref="zTable"
      :data="tableData"
    >
      <el-table-column
        fixed
        label="序号"
        align="center"
        width="70px"
      >
        <template slot-scope="scope">
          {{ scope.$index+1 }}
        </template>
      </el-table-column>
      <!-- <af-table-column
        fixed
        prop="marketName"
        label="组织"
      /> -->
      <af-table-column
        fixed
        prop="tradingDate"
        label="委托日期"
      />
      <af-table-column
        fixed
        prop="entrustTimeStr"
        label="委托时间"
      />
      <af-table-column
        prop="entrustWayStr"
        label="委托方式"
      />
      <af-table-column
        prop="entrustNo"
        label="委托编号"
      />
      <af-table-column
        prop="userAccount"
        label="客户"
      />
      <af-table-column
        prop="tradeUserAccount"
        label="客户号"
      />
      <af-table-column
        prop="userName"
        label="客户名称"
      />
      <af-table-column
        prop="areaName"
        label="区域"
      />
      <af-table-column
        prop="goodsCode"
        label="套利购销计划"
      />
      <af-table-column
        prop="entrustTsStr"
        label="订/变"
      />
      <af-table-column
        prop="entrustBsStr"
        label="购/销"
      />
      <af-table-column
        prop="entrustAmount"
        label="委托数量"
      />
      <af-table-column
        prop="entrustPriceStr"
        label="委托价格"
      />
      <af-table-column
        prop="surplusFrozenBailStr"
        label="订单担保履约资金"
      />
      <af-table-column
        prop="businessAmount"
        label="成交数量"
      />
      <af-table-column
        prop="entrustStatusStr"
        label="委托状态"
      />
      <af-table-column
        prop="entrustAddress"
        label="委托地址"
      />
    </el-table>
    <el-pagination
      class="pagination"
      layout="total, prev, pager, next"
      :current-page.sync="currentPage"
      :total="total"
      background
      @current-change="changePage"
    />
  </div>
</template>
<script>
import api from '@/api'
import dayJs from 'dayjs'

function Query () {
  this.marketId = '000' // 组织编号
  this.userAccount = '' // 客户
  this.tradeUserAccount = '' // 客户号
  this.entrustNo = '' // 委托编号
  this.entrustTs = '' // 订变
  this.entrustBs = '' // 购销
  this.goodsCode = '' // 近期购销计划代码
  this.goodsCodeOther = '' // 远期购销计划代码
  this.date = [] // 委托日期
}

export default {
  name: 'HistoricalArbitrageInquiry',
  data () {
    return {
      query: new Query(),

      currentPage: 1,
      total: 0,
      pageSize: 10,
      marketId: '',
      tableData: [], // 表格数据
    }
  },
  mounted () {
    this.fetchList(1)
  },
  methods: {
    // 分页查询
    async fetchList (currentPage, pageSize) {
      if (pageSize) {
        this.pageSize = pageSize
      }
      this.currentPage = currentPage || this.currentPage || 1
      let param = {
        ...this.query,
        currentPage: this.currentPage,
        pageSize: this.pageSize
      }
      param.tradingDateBegin = this.query.date.length ? dayJs(this.query.date[0]).format('YYYY-MM-DD') : ''
      param.tradingDateEnd = this.query.date.length ? dayJs(this.query.date[1]).format('YYYY-MM-DD') : ''
      let res = await api.spotPurchaseSaleInquiry.HistoricalArbitrageInquiry(param)
      this.total = res.data.totalItem
      this.tableData = res.data.items
      this.marketId = this.query.marketId
    },
    // 重置搜索
    handleReset () {
      this.query = new Query()
      this.fetchList(1)
    },
    // 换页
    changePage (page) {
      this.fetchList(page)
    },
    // 导出
    toDownload () {
      let param = {
        marketId: this.marketId,
        execlType: '12',
        excelHead: [
          // {
          //   fieldLabel: '组织',
          //   excelColumn: 'marketName'
          // },
          {
            fieldLabel: '委托日期',
            excelColumn: 'tradingDate'
          },
          {
            fieldLabel: '委托时间',
            excelColumn: 'entrustTimeStr'
          },
          {
            fieldLabel: '委托方式',
            excelColumn: 'entrustWayStr'
          },
          {
            fieldLabel: '委托编号',
            excelColumn: 'entrustNo'
          },
          {
            fieldLabel: '客户',
            excelColumn: 'userAccount'
          },
          {
            fieldLabel: '客户号',
            excelColumn: 'tradeUserAccount'
          },
          {
            fieldLabel: '客户名称',
            excelColumn: 'userName'
          },
          {
            fieldLabel: '区域',
            excelColumn: 'areaName'
          },
          {
            fieldLabel: '套利购销计划',
            excelColumn: 'goodsCode'
          },
          {
            fieldLabel: '订/变',
            excelColumn: 'entrustTsStr'
          },
          {
            fieldLabel: '购/销',
            excelColumn: 'entrustBsStr'
          },
          {
            fieldLabel: '委托数量',
            excelColumn: 'entrustAmount'
          },
          {
            fieldLabel: '委托价格',
            excelColumn: 'entrustPriceStr'
          },
          {
            fieldLabel: '订单担保履约资金',
            excelColumn: 'surplusFrozenBailStr'
          },
          {
            fieldLabel: '成交数量',
            excelColumn: 'businessAmount'
          },
          {
            fieldLabel: '委托状态',
            excelColumn: 'entrustStatusStr'
          },
          {
            fieldLabel: '委托地址',
            excelColumn: 'entrustAddress'
          }
        ]
      }
      this.$utils.getExcelFile(this, api.download, param)
    }
  }
}

</script>
<style lang="scss" scoped>
  .hideTotal ::v-deep .el-table__fixed .el-table__fixed-body-wrapper tbody>tr:last-child td:nth-child(2) div,
  .hideTotal ::v-deep > .el-table .el-table__body-wrapper tbody>tr:last-child td:nth-child(5) div {
    display: none;
  }

  .hideTotal ::v-deep .el-col.el-col-24.el-col-sm-24.el-col-md-6:nth-child(6) {
    width: 550px;
  }

</style>
